import { useState, useEffect } from "react";

import { Button } from "shared/components/bulma/button";

import * as helper from "./helper";

const RowSize = ({ size, onChange, onNextBarcode, startBarcode = "", endBarcode = "00000" }) => {
    const [count, setCount] = useState(1);
    const [firstBarcode, setFirstBarcode] = useState(startBarcode);
    const [lastBarcode, setLastBarcode] = useState(endBarcode);
    const [nextBarcode, setNextBarcode] = useState("");

    const handleCountChange = (event) => {
        const newCount = event.target.value;
        setCount(newCount);

        if (Number(firstBarcode) !== 0) {
            const newLastBarcode = helper.addToString(firstBarcode, newCount - 1);
            setNextBarcode(helper.addToString(newLastBarcode, 1));
            setLastBarcode(newLastBarcode);
            onChange && onChange({ size, endBarcode: newLastBarcode, startBarcode: firstBarcode });
        }
    }

    const handleBarcodeChange = (event) => {
        const barcode = event.target.value;

        if (isNaN(Number(barcode))) {
            return;
        }

        setFirstBarcode(barcode);

        if (Number(barcode) !== 0) {
            const newLastBarcode = helper.addToString(barcode, count - 1);
            setLastBarcode(newLastBarcode);
            setNextBarcode(helper.addToString(newLastBarcode, 1));

            onChange && onChange({ size, endBarcode: newLastBarcode, startBarcode: barcode });
        }
    }
    const handleNextBarcode = () => {
        onNextBarcode({ nextBarcode, size });
    }
    useEffect(() => {
        const reset = () => {
            setCount(1);
            setFirstBarcode("");
            setLastBarcode("00000");
            setNextBarcode("");
        };
        if (!startBarcode) {
            reset();
        } else {
            setFirstBarcode(startBarcode);
        };

    }, [startBarcode]);

    return (
        <div className="columns is-vcentered is-variable is-8">
            <div className="column">
                <p className="subtitle is-4">{size}</p>
            </div>
            <div className="column">
                <div className="field">
                    <div className="control">
                        <input
                            className="input"
                            name="first-barcode"
                            type="text"
                            value={firstBarcode}
                            onChange={handleBarcodeChange}
                            placeholder="First Barcode" />
                    </div>
                </div>
            </div>
            <div className="column is-2">
                <div className="field">
                    <div className="control">
                        <input
                            className="input"
                            name="count"
                            min="1"
                            type="number"
                            value={count}
                            onChange={handleCountChange}
                            placeholder="Count" />
                    </div>
                </div>
            </div>
            <div className="column is-centered">
                <div className="field">
                    <div className="control">
                        <p className="tag is-light is-link is-medium"
                            name="last-barcode"
                            placeholder="Last Barcode"
                        >{lastBarcode}</p>
                    </div>
                </div>
            </div>
            <div className="column is-2">
                <Button className="is-info is-outlined"
                    onClick={handleNextBarcode}
                >
                    <span>Use {nextBarcode}</span>
                </Button>
            </div>
        </div>
    )
}
export { RowSize };
